import { type WorkoutItemGroupType } from "api-client/legacy-trpc";

import { type GroupWorkoutItemData } from "src/workouts/WorkoutEditStore";

import { DurationField } from "./DurationField";
import { InstructionsField } from "./InstructionsField";
import { SectionFieldsContainer } from "./SectionFieldsContainer";
import { SectionTypeField } from "./SectionTypeField";

interface AmrapSectionFieldsProps {
  workoutItem: GroupWorkoutItemData;
  onUpdate: (updates: Partial<GroupWorkoutItemData>) => void;
}

export function AmrapSectionFields(props: AmrapSectionFieldsProps) {
  function handleStopPropagation(e: React.MouseEvent) {
    e.stopPropagation();
  }

  return (
    <SectionFieldsContainer onClick={handleStopPropagation}>
      <div className="flex justify-between gap-3">
        <SectionTypeField
          value={props.workoutItem.groupType}
          onChange={(value: WorkoutItemGroupType) => {
            props.onUpdate({ groupType: value });
          }}
        />
        <DurationField
          value={props.workoutItem.durationMinutes}
          onChange={(value) => {
            props.onUpdate({ durationMinutes: value });
          }}
        />
      </div>
      <InstructionsField
        value={props.workoutItem.instructions}
        onChange={(value) => {
          props.onUpdate({ instructions: value });
        }}
      />
    </SectionFieldsContainer>
  );
}
